module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point01_04_travel-1d7d11acf1fb49491e48b5bfc188d168.jpg";